/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.target = this.dataset.target; // Use section.id to target the slider
      this.buttons = Array.from(this.querySelectorAll('button'));
      this.seeMoreButtons = Array.from(this.querySelectorAll('.collection-tabs__see-more'));
      this.syncActiveButtonState();

      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const handle = button.dataset.collection;

          // Remove the active class from all buttons when a new button is clicked
          // Call forEach on this.buttons regardless of whether it is a true array ot not
          [].forEach.call(this.buttons, function (el) {
            el.classList.remove('active');
            el.setAttribute('aria-pressed', 'false');
          });
          [].forEach.call(this.seeMoreButtons, function (el) {
            el.classList.remove('active');
          });

          // Add the active class to the clicked button
          button.classList.add('active');
          button.setAttribute('aria-pressed', 'true');
          // Toggle the collection
          if (handle) {
            this.toggleCollection(handle);
            this.toggleSeeMore(handle);
          }
        });
      });

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }

    toggleSeeMore(handle) {
      const seeMoreButton = this.seeMoreButtons.find((button) => button.dataset.collection === handle);
      if (seeMoreButton) {
        seeMoreButton.classList.add('active');
      }
    }

    syncActiveButtonState() {
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', button.classList.contains('active') ? 'true' : 'false');
      });
    }

    toggleCollection(handle) {
      // Target the .product-slider element that Flicky is initialized on
      const slider = $(`#${this.target}`); // = "product-slider-{{ section.id }}"
      const products = slider.find('div.gallery-cell').not(`[data-collection="${handle}"]`);
      const active_products = slider.find(`div.gallery-cell[data-collection="${handle}"]`);

      // Hide all other collection products
      products.hide();
      // Show active products
      active_products.css('display', 'flex');

      // Instead of using slider.flickity('remove', products)
      // Move other collection products outside of Flickity carousel (slider)
      slider.append(products);

      // Add active products to the slider
      slider.flickity('insert', active_products);
      // Update the slider after cells have been added or removed
      slider.flickity('reloadCells');
      // Recalculate the size of the slider
      slider.flickity('resize');
      // To move to the first cell (0), with no transition (0), and to consider the wrap-around (1).
      slider.flickity('select', 0, 0, 1);
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
